/**
 * PRODUÇÃO PERICIAL — lista de laudos com status real
 * Fonte: /api/laudos/listar.php
 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, ChevronRight, FileText } from 'lucide-react';

export default function ProducaoCard() {
  const [laudos, setLaudos]   = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate              = useNavigate();

  useEffect(() => {
    fetch('/api/laudos/listar.php', { credentials: 'include' })
      .then(r => r.json())
      .then(d => { if (d.success) setLaudos(d.laudos || []); })
      .catch(err => console.error('[Producao]', err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="bg-[#0A0F1E] border border-white/[0.06] rounded-2xl p-6 flex justify-center">
        <Loader2 className="animate-spin text-blue-400" size={20} />
      </div>
    );
  }

  // Agrupa por status — SEM hardcode, usando o que vem do banco
  const porStatus = {};
  laudos.forEach(l => {
    const s = l.status || 'SEM_STATUS';
    porStatus[s] = (porStatus[s] || 0) + 1;
  });
  const statusUnicos = Object.keys(porStatus).sort();

  return (
    <div className="bg-[#0A0F1E] border border-white/[0.06] rounded-2xl p-6">

      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-[10px] font-bold text-blue-400 uppercase tracking-[0.2em]">
            Produção Pericial
          </h3>
          <p className="text-[9px] text-slate-500 uppercase tracking-wider mt-1">
            Laudos por status
          </p>
        </div>
        <div className="text-right">
          <p className="text-2xl font-black text-white leading-none">{laudos.length}</p>
          <p className="text-[8px] text-slate-500 uppercase tracking-widest mt-1">Total</p>
        </div>
      </div>

      {laudos.length === 0 ? (
        <div className="text-center py-8">
          <FileText size={32} className="mx-auto text-slate-700 mb-3" />
          <p className="text-slate-500 text-xs">Nenhum laudo cadastrado.</p>
          <button
            onClick={() => navigate('/laudos/novo')}
            className="mt-4 px-4 py-2 rounded-xl bg-blue-600 hover:bg-blue-500 text-white text-[10px] font-bold uppercase tracking-widest transition-all"
          >
            + Novo Laudo
          </button>
        </div>
      ) : (
        <>
          {/* Resumo por status */}
          <div className="space-y-1 mb-4">
            {statusUnicos.map(s => (
              <div
                key={s}
                className="flex items-center justify-between p-2.5 rounded-lg hover:bg-white/[0.03]"
              >
                <span className="text-slate-400 text-xs uppercase tracking-wider">
                  {s.replace(/_/g, ' ')}
                </span>
                <span className="text-white font-bold text-sm">{porStatus[s]}</span>
              </div>
            ))}
          </div>

          {/* Lista dos laudos */}
          <div className="border-t border-white/[0.06] pt-4 mt-4">
            <p className="text-[9px] text-slate-500 uppercase tracking-widest mb-3">
              Últimos laudos
            </p>
            <div className="space-y-1 max-h-[280px] overflow-y-auto pr-1">
              {laudos.slice(0, 10).map(l => (
                <button
                  key={l.id}
                  onClick={() => navigate(`/laudos/${l.codigo_mh}/abertura`)}
                  className="w-full flex items-center justify-between p-3 rounded-xl hover:bg-white/[0.03] text-left transition-all group"
                >
                  <div className="min-w-0 flex-1">
                    <p className="text-white font-bold text-sm truncate">
                      {l.codigo_mh || `#${l.id}`}
                    </p>
                    <p className="text-slate-500 text-[10px] uppercase tracking-wider mt-0.5 truncate">
                      {l.perito_nome || '—'} • {l.status?.replace(/_/g, ' ') || '—'}
                    </p>
                  </div>
                  <ChevronRight size={14} className="text-slate-600 group-hover:text-blue-400 transition-colors shrink-0" />
                </button>
              ))}
            </div>
          </div>
        </>
      )}

    </div>
  );
}